/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,        
    InputAdornment,     
    FormControl,         
    InputLabel,         
    Select,             
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    AttachMoney,
    Add,
    NavigateNext,
    NavigateBefore,
    List as ListIcon,
    Edit as EditIcon,
    Block as BlockIcon,
    CheckCircle as ActivateIcon,
    Search as SearchIcon,   
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useBudgetLine } from 'hooks/api/terminology/budget-line/useBudgetLine';
import { useProjectCode } from 'hooks/api/terminology/project-code/useProjectCode';
import { useBranchCode } from 'hooks/api/terminology/branch-code/useBranchCode';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';
import AddEditBudgetLine from './add';
import {
    BudgetCell,
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    formatConfigurationDate,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'Budget Line Name' },
        { value: 'code', label: 'Budget Line Code' },
        { value: 'projectCode.name', label: 'Project Code' },
        { value: 'projectCode.branchCode.name', label: 'Branch Code' },
        { value: 'fiscalYear', label: 'Fiscal Year' },
        { value: 'description', label: 'Description' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'lastModifiedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'Budget Line Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

const BudgetLineList = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    // States for pagination and data
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');

    // Hooks
    const { listBudgetLine, updateBudgetLine, budgetLines } = useBudgetLine();
    const { listProjectCodes, projectCodes } = useProjectCode();
    const { listBranchCodes, branchCodes } = useBranchCode();

    // Additional states
    const [editingBudgetLine, setEditingBudgetLine] = useState(null);
    const [toggleConfirmOpen, setToggleConfirmOpen] = useState(false);
    const [budgetLineToToggle, setBudgetLineToToggle] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initial data fetch
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            const results = await Promise.all([
                listBudgetLine(0, 100), 
                listProjectCodes(0, 100), 
                listBranchCodes(0, 100)
            ]);
        
        } catch (error) {
            logger.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to get nested object value
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : null;
        }, obj);
    };

    // Filter budget lines based on search
    const getFilteredBudgetLines = () => {
        if (!searchTerm.trim()) {
            return budgetLines;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return budgetLines.filter((budgetLine) => {
            const fieldValue = getNestedValue(budgetLine, searchField);
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };

    const filteredBudgetLines = getFilteredBudgetLines();

    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleEditClick = (budgetLine) => {
        setEditingBudgetLine(budgetLine);
        setActiveTab(1);
    };

    const handleAddNew = () => {
        setEditingBudgetLine(null);
        setActiveTab(1);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setEditingBudgetLine(null);
        }
    };

    const handleToggleActive = async (budgetLine) => {
        setBudgetLineToToggle(budgetLine);
        setToggleConfirmOpen(true);
    };

    const handleToggleConfirm = async () => {
        try {
            const updatedBudgetLine = { ...budgetLineToToggle, isActive: !budgetLineToToggle.isActive };
            await updateBudgetLine(budgetLineToToggle.id, updatedBudgetLine);
            await fetchInitialData();
            setToggleConfirmOpen(false);
            setBudgetLineToToggle(null);
            Swal.fire({
                icon: 'success',
                title: budgetLineToToggle.isActive ? 'Budget Line Deactivated' : 'Budget Line Activated',
                text: `The budget line has been successfully ${budgetLineToToggle.isActive ? 'deactivated' : 'activated'}.`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error toggling budget line status:', error);
            
            let errorMessage = 'Failed to update budget line status. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleToggleCancel = () => {
        setToggleConfirmOpen(false);
        setBudgetLineToToggle(null);
    };

    const handleBudgetLineSubmitted = () => {
        fetchInitialData();
        setActiveTab(0);
        setEditingBudgetLine(null);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount || 0);
    };

    const renderBudgetLinesList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredBudgetLines.length} of {budgetLines.length} budget lines
                            {filteredBudgetLines.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {budgetLines.length} budget lines</>
                    )}
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddNew}
                    sx={{
                        backgroundColor: globalColor,
                        '&:hover': {
                            backgroundColor: globalColor,
                            opacity: 0.9
                        }
                    }}
                >
                    Add New Budget Line
                </Button>
            </Box>

            <Fade in timeout={1000}>
                <StyledTableContainer component={Paper}>
                    <Table size="small" sx={tableSx(980)}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 68 }}>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ width: 108 }}>Code</TableCell>
                                <TableCell sx={{ width: 124 }}>Branch</TableCell>
                                <TableCell sx={{ width: 124 }}>Project</TableCell>
                                <TableCell sx={{ width: 88 }}>Fiscal Year</TableCell>
                                <TableCell sx={{ width: 132 }}>Budget</TableCell>
                                <TableCell sx={{ width: 118 }}>Created</TableCell>
                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredBudgetLines.length > 0 ? (
                                filteredBudgetLines.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((budgetLine) => (
                                    <TableRow key={budgetLine.id}>
                                        <TableCell><CodeText>{budgetLine.id}</CodeText></TableCell>
                                        <TableCell><ClampedText>{budgetLine.name}</ClampedText></TableCell>
                                        <TableCell><CodeText>{budgetLine.code}</CodeText></TableCell>
                                        <TableCell>
                                            <ClampedText maxWidth={124}>{budgetLine.projectCode?.branchCode?.name}</ClampedText>
                                        </TableCell>
                                        <TableCell><ClampedText maxWidth={124}>{budgetLine.projectCode?.name}</ClampedText></TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{budgetLine.fiscalYear || 'N/A'}</TableCell>
                                        <TableCell>
                                            <BudgetCell
                                                primary={budgetLine.initialBudget}
                                                secondary={budgetLine.currentBalance}
                                                formatCurrency={formatCurrency}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatConfigurationDate(budgetLine.createdAt)}</TableCell>
                                        <TableCell>
                                            <ConfigurationStatusChip active={budgetLine.isActive} />
                                        </TableCell>
                                        <TableCell align="center" sx={stickyActionCellSx}>
                                            <ConfigurationActionMenu
                                                label={budgetLine.name}
                                                actions={[
                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(budgetLine) },
                                                    {
                                                        label: budgetLine.isActive ? 'Deactivate' : 'Activate',
                                                        icon: budgetLine.isActive ? BlockIcon : ActivateIcon,
                                                        color: budgetLine.isActive ? '#b54708' : '#25643b',
                                                        onClick: () => handleToggleActive(budgetLine)
                                                    }
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={10} align="center">
                                        <Box sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchTerm ? (
                                                    <>
                                                        No budget lines found matching "{searchTerm}" in {searchField}
                                                        <Box sx={{ mt: 2 }}>
                                                            <Typography
                                                                variant="body2"
                                                                color="primary"
                                                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear search to view all budget lines
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    'No budget lines available'
                                                )}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <ConfigurationPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={filteredBudgetLines.length}
                        onPageChange={setPage}
                    />
                </StyledTableContainer>
            </Fade>
        </Box>
    );

    const renderToggleDialog = () => (
        <Dialog open={toggleConfirmOpen} onClose={handleToggleCancel}>
            <DialogTitle>
                {budgetLineToToggle?.isActive ? 'Deactivate Budget Line' : 'Activate Budget Line'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to {budgetLineToToggle?.isActive ? 'deactivate' : 'activate'} the budget line "{budgetLineToToggle?.name}"?
                    {budgetLineToToggle?.isActive && ' This will make the budget line unavailable for use.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleToggleCancel}>Cancel</Button>
                <Button 
                    onClick={handleToggleConfirm} 
                    color={budgetLineToToggle?.isActive ? 'warning' : 'success'} 
                    variant="contained"
                >
                    {budgetLineToToggle?.isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Budget Lines List" />
                    <Tab icon={<Add />} iconPosition="start" label={editingBudgetLine ? 'Edit Budget Line' : 'Add New Budget Line'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                renderBudgetLinesList()
            ) : (
                <AddEditBudgetLine
                    editingBudgetLine={editingBudgetLine}
                    onBudgetLineSubmitted={handleBudgetLineSubmitted}
                    projectCodes={projectCodes}
                    branchCodes={branchCodes}
                />
            )}
            
            {renderToggleDialog()}
        </Box>
    );
};

export default BudgetLineList;
